export default "__VITE_ASSET__DKMt$VYT__"